import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
  message
} from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ResponsiveContainer from '../../../components/ResponsiveContainer';
import TableAndFilters from '../../../components/TableAndFilters';
import { instanceRef } from '../../../utils/axios';
import { fieldTypes, filterConditions } from '../../../utils/filter-utils';

const { Option } = Select;

function Modelos() {
  const tableRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [marcas, setMarcas] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState(null);
  const [editData, setEditData] = useState(null);
  const [recordToEdit, setRecordToEdit] = useState();

  const [defaultFilters, setDefaultFilters] = useState({
    id_marca: {
      value: -1, // Valor inicial ara obtener un listado vacio, ya que es necesario mostrar la tabla vacia porque existen botones "Agregar" que se deben mostrar si o si.
      filterType: fieldTypes.NUMERIC,
      filterCondition: filterConditions.EQUALS
    }
  });

  const columnas = [
    {
      title: 'Código',
      dataIndex: ['codigo']
    },
    {
      title: 'Descripción',
      dataIndex: ['descripcion']
    },
    {
      title: 'Marca',
      dataIndex: ['marca', 'descripcion']
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (record) => {
        return (
          <Space>
            <Tooltip title="Editar">
              <Button
                type="text"
                icon={<EditOutlined />}
                size="middle"
                style={{ color: 'rgba(0,0,0,.45)' }}
                onClick={() => {
                  form.setFieldsValue({
                    codigo: record.codigo,
                    id_marca: record.id_marca,
                    descripcion: record.descripcion
                  });
                  setEditData(true);
                  setRecordToEdit(record);
                  setIsModalOpen(true);
                }}
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <DeleteOutlined style={{ color: 'rgba(0,0,0,.45)' }} disabled />
            </Tooltip>
          </Space>
        );
      }
    }
  ];

  const ModalCrearModelo = () => {
    return (
      <Modal
        title={!editData ? 'Agregar Modelo' : 'Editar Modelo'}
        open={isModalOpen}
        onCancel={handleClose}
        footer={
          <Button
            type="primary"
            onClick={() => {
              form.validateFields().then((values) => {
                handleFormSubmit(values);
              });
            }}
          >
            Guardar
          </Button>
        }
      >
        <Spin spinning={loading} size="large" tip="Cargando...">
          <Form
            form={form}
            layout="vertical"
            initialValues={{ id_marca: marcaSeleccionada }}
          >
            <Form.Item
              label="Marca"
              name="id_marca"
              rules={[{ required: true, message: 'Este campo es requerido' }]}
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                placeholder="Seleccionar Marca"
                onChange={(value) => {
                  form.setFieldValue('descripcion', '');
                  getUltimoCodigoModelo(value);
                  setMarcaSeleccionada(value);
                }}
                disabled
              >
                {marcas.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/*  <Form.Item
              name="codigo"
              label="Código"
              rules={[
                { required: true, message: 'Este campo es requerido' },
                {
                  validator: async (_, value) => {
                    if (!value) return Promise.resolve();
                    return validarCodigoExistente('codigo', value);
                  }
                }
              ]}
            >
              <Input disabled />
            </Form.Item> */}

            <Form.Item
              name="descripcion"
              label="Descripción"
              rules={[
                { required: true, message: 'Este campo es requerido' },
                {
                  validator: async (_, value) => {
                    if (!value) return Promise.resolve();
                    return validarCodigoExistente('descripcion', value);
                  }
                }
              ]}
            >
              <Input
                onChange={(e) => {
                  const descripcion = e.target.value.toUpperCase();
                  form.setFieldValue('descripcion', descripcion);
                  form.validateFields(['descripcion']);
                }}
                disabled={!marcaSeleccionada}
              />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  };

  const handleClose = () => {
    setEditData(false);
    form.resetFields();
    setIsModalOpen(false);
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    try {
      const data = {
        id: recordToEdit && recordToEdit.id,
        idMarca: values.id_marca,
        codigo: values.codigo,
        descripcion: values.descripcion.toUpperCase()
      };
      const url = editData ? '/modelo/update' : '/modelo/add';

      const response = await instanceRef.instance.post(url, data);
      if (response.data?.data) {
        message.success('Modelo registrado correctamente');
        tableRef.current.reload();
      }
      setEditData(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error('El Modelo no pudo ser registrado');
      // error
    }
    // cerrar modal
    handleClose();
  };

  const onChangeMarca = (value) => {
    setDefaultFilters({
      id_marca: {
        value: Number(value),
        filterType: fieldTypes.NUMERIC,
        filterCondition: filterConditions.EQUALS
      }
    });
    setTimeout(() => {
      tableRef.current.reload();
    }, 500);
  };

  const getUltimoCodigoModelo = useCallback(
    async (idMarca) => {
      try {
        const response = await instanceRef.instance.get(
          `modelo/last/${idMarca}`
        );
        if (response.data?.data) {
          const ultimoCodigo = Number(response.data.data.codigo) + 1;
          form.setFieldValue('codigo', ultimoCodigo);
        }
      } catch (error) {
        // error
      }
    },
    [form]
  );

  const validarCodigoExistente = async (name, value) => {
    try {
      const data = {
        codigo: name === 'codigo' ? value : null,
        descripcion: name === 'descripcion' ? value.toUpperCase() : null,
        idMarca: form.getFieldValue('id_marca')
      };
      const response = await instanceRef.instance.post(
        '/modelo/validate',
        data
      );
      const modeloExiste = response.data?.data?.existe;
      if (modeloExiste && name === 'codigo' && !recordToEdit) {
        throw new Error('El código ya está en uso');
      }
      if (modeloExiste && name === 'descripcion') {
        throw new Error('La descripción del Modelo ya está en uso');
      }
    } catch (err) {
      throw new Error(err.message || 'Error validando el código');
    }
    return Promise.resolve();
  };

  const getMarcas = useCallback(async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(`data/marcas`);
      const orderedMarcas = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setMarcas(orderedMarcas);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // error
    }
  }, []);

  useEffect(() => {
    getMarcas();
  }, [getMarcas]);

  return (
    <ResponsiveContainer size="large" style={{ paddingTop: 0 }}>
      <Card style={{ marginBottom: 5, textAlign: 'left' }} title="Filtros">
        <Form
          initialValues={{ marca: null }}
          scrollToFirstError
          layout="horizontal"
          name="historico"
          autoComplete="off"
        >
          <Row justify="start">
            <Col xs={24} md={12}>
              <Form.Item label="Marca" name="id_marca">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  optionFilterProp="children"
                  onChange={(value) => {
                    onChangeMarca(value);
                    setMarcaSeleccionada(value);
                  }}
                >
                  {marcas.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      {defaultFilters && (
        <TableAndFilters
          ref={tableRef}
          withGeneralFilter
          url="/modelo"
          defaultFilters={defaultFilters}
          title={`
                 Gestión de Modelos`}
          columns={columnas}
          showTable
          hasExportar
          extra={[
            <Button
              key="agregarModelo"
              type="dashed"
              shape="round"
              icon={<PlusCircleOutlined />}
              size="middle"
              onClick={() => {
                setIsModalOpen(true);
              }}
              disabled={!marcaSeleccionada}
            >
              Agregar Modelo
            </Button>
          ]}
        />
      )}

      <ModalCrearModelo />
    </ResponsiveContainer>
  );
}

export default Modelos;
